import React from 'react';
import { HelpTooltip } from './HelpTooltip';
import { wt } from './widgetTokens';

interface SwitchWidgetProps {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  description?: string;
  helpText?: string;
}

export const SwitchWidget: React.FC<SwitchWidgetProps> = ({
  label,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  description,
  helpText
}) => {
  return (
    <div className={wt.container}>
      <div className={wt.switchRow}>
        <div className={wt.labelRow}>
          <label className={wt.switchLabel}>
            {label}
            {required && <span className={wt.required}>*</span>}
          </label>
          {helpText && <HelpTooltip helpText={helpText} />}
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={!!value}
          aria-label={label}
          onClick={() => !disabled && onChange(!value)}
          disabled={disabled}
          className={`${wt.switchTrack(value)} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <span className={wt.switchThumb(value)} />
        </button>
      </div>
      {description && <p className={wt.description}>{description}</p>}
      {error && <p className={wt.errorMsg}>{error}</p>}
    </div>
  );
};

export default SwitchWidget;
